import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePilotFlags } from '../config/pilotFlags';
import {
  isUnityBillingRestricted,
  parseUnitySourceFromSearch,
  readStoredUnitySource,
  storeUnitySource,
} from '../utils/billingVisibility';

const useBillingVisibility = () => {
  const pilotFlags = usePilotFlags();
  const location = useLocation();
  const [unitySource, setUnitySource] = useState(() => (
    parseUnitySourceFromSearch(typeof window !== 'undefined' ? window.location.search : '')
    || readStoredUnitySource()
  ));

  useEffect(() => {
    const locationSearch = typeof location?.search === 'string' ? location.search : '';
    const sourceFromUrl = parseUnitySourceFromSearch(locationSearch);
    if (!sourceFromUrl) {
      return;
    }

    storeUnitySource(sourceFromUrl);
    setUnitySource(sourceFromUrl);
  }, [location?.search]);

  const isUnityRestrictedBilling = useMemo(
    () => isUnityBillingRestricted(unitySource),
    [unitySource]
  );
  const shouldShowBilling = !pilotFlags.hideBillingUi && !isUnityRestrictedBilling;

  return {
    ...pilotFlags,
    unitySource,
    isUnityRestrictedBilling,
    shouldShowBilling,
  };
};

export default useBillingVisibility;
